import React from 'react';
import Loader from '../../elements/Loader'
import links from '../../helpers/projects'

const ProjectsPage = (props) => {

    let { currentUser, isLoading } = props
    const groups = currentUser.optional && currentUser.optional.groups ? currentUser.optional.groups : []

    return (<div>
        {isLoading && <Loader />}

        <h1 className="text-center">Projects</h1>

        {(currentUser && currentUser.optional && currentUser.optional.role === 'admin') ?
            links.map((el) => <div key={el.name} className=" ml-3 ">
                <a href={el.url}>{el.name}</a>
            </div>
            )
            :
            links.map((el) => groups.some((i) => i.includes(el.name)) && <div key={el.name} className=" ml-3 ">
                <a href={el.url} >{el.name}
                </a></div>)
        }

    </div>)
}

export default ProjectsPage